export default "Review optimization run #{{optimizationId}} and determine whether its trades are safe to execute.\n"